'use strict';class Provider{constructor(){}getAll(){return this.data;}}module.exports=Provider;